/**
 * Help search — debounced query against /api/help-search.php, results rendered
 * in a dropdown under the input. Lang (market) comes from the block's data-lang.
 */
export function helpSearch() {
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  document.querySelectorAll('[data-help-search]').forEach((box) => {
    const input = box.querySelector('[data-help-search-input]');
    const results = box.querySelector('[data-help-search-results]');
    if (!input || !results) return;
    const lang = box.dataset.lang || 'en';
    let timer;

    const run = async () => {
      const q = input.value.trim();
      if (q.length < 2) {
        results.classList.add('hidden');
        results.innerHTML = '';
        return;
      }
      try {
        const r = await fetch(`/api/help-search.php?q=${encodeURIComponent(q)}&lang=${encodeURIComponent(lang)}`);
        const d = await r.json();
        if (!d.ok || !d.results || !d.results.length) {
          results.innerHTML = `<div class="px-5 py-4 text-sm text-dark-500">${escapeHtml(results.dataset.empty || '')}</div>`;
          results.classList.remove('hidden');
          return;
        }
        results.innerHTML = d.results
          .map(
            (a) =>
              `<a href="${escapeHtml(a.url)}" class="block border-b border-dark-150 px-5 py-3 last:border-0 hover:bg-dark-150">` +
              `<span class="block text-sm text-white">${escapeHtml(a.title)}</span>` +
              (a.excerpt ? `<span class="mt-0.5 block text-xs text-dark-500">${escapeHtml(a.excerpt)}</span>` : '') +
              `</a>`
          )
          .join('');
        results.classList.remove('hidden');
      } catch (e) {
        results.classList.add('hidden');
      }
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(run, 250);
    });
    document.addEventListener('click', (e) => {
      if (!box.contains(e.target)) results.classList.add('hidden');
    });
  });
}
